import script from "./DecorationAgreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationAgreement.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationAgreement.vue?vue&type=style&index=0&id=5e0f7957&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0f7957"]])

export default __exports__